// extracted by mini-css-extract-plugin
export default {"navBox":"HeaderNav_navBox__SrYUR","mobile":"HeaderNav_mobile__BPcNr","nav":"HeaderNav_nav__tXKO8","divider":"HeaderNav_divider__EKya2","desktop":"HeaderNav_desktop__C-xok"};